import { createContext } from 'react';
import { QUERY_KEYS_PHONES, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const PhonesChartsDataContext = createContext();

const PhonesChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_BRAND,
            url: 'governanceroom/securitydashboard/phones/brand'
        },
        filterParams
    );

    const typeEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_TYPE,
            url: 'governanceroom/securitydashboard/phones/types'
        },
        filterParams
    );

    const subtypeEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_SUBTYPE,
            url: 'governanceroom/securitydashboard/phones/subtypes'
        },
        filterParams
    );

    const blockStatusEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_BLOCKSTATUS,
            url: 'governanceroom/securitydashboard/phones/blockStatus'
        },
        filterParams
    );

    const quantityEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_QUANTITY,
            url: 'governanceroom/securitydashboard/phones/quantity'
        },
        filterParams
    );

    const chartData = {
            brandAnual: data?.anualEvolution || [],
            brandMonth: data?.monthEvolution || [],
            typeAnual: typeEvolutionData.data?.anualEvolution || [],
            typeMonth: typeEvolutionData.data?.monthEvolution || [],
            subtypeAnual: subtypeEvolutionData.data?.anualEvolution || [],
            subtypeMonth: subtypeEvolutionData.data?.monthEvolution || [],
            blockStatusAnual: blockStatusEvolutionData.data?.anualEvolution || [],
            blockStatusMonth: blockStatusEvolutionData.data?.monthEvolution || [],
            quantityAnual: quantityEvolutionData.data?.anualEvolution || [],
            quantityMonth: quantityEvolutionData.data?.monthEvolution || []
          }

    return (
        <PhonesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </PhonesChartsDataContext.Provider>
    );
};

export default PhonesChartsDataProvider;
